module.exports = __webpack_public_path__ + "img/top-bg-hen.81f84970.png";